import { KeyboardEventHandler } from 'react';

export const restrictDecimalHandler: KeyboardEventHandler = (e) => {
    const restrictedChars = ['.', ',', '-', 'e'];
    if (restrictedChars.includes(e.key)) {
        e.preventDefault();
    }
};
